import { createRoute, Outlet } from "@tanstack/react-router";
import { UserActivityScreen } from "@/app/Users/Screens/UserActivityScreen";
import { UserDetailsScreen } from "@/app/Users/Screens/UserDetailsScreen";
import { UserOrganisationsScreen } from "@/app/Users/Screens/UserOrganisationsScreen";
import { UserListScreen } from "@/app/Users/Screens/UserListScreen";
import { UserRecordScreen } from "@/app/Users/Screens/UserRecordScreen";
import { appLayoutRoute } from "@/routes/layout-routes";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { userRecordQuery } from "@/app/Users/GraphQL/userRecordQuery";

export const usersLayoutRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/users",
  component: Outlet,
});

export const userListRoute = createRoute({
  getParentRoute: () => usersLayoutRoute,
  path: "/",
  component: UserListScreen,
  head: () => ({
    meta: [
      {
        title: "Users - Imoova Admin",
      },
      {
        name: "description",
        content: "Manage users",
      },
    ],
  }),
});

export const userRoute = createRoute({
  getParentRoute: () => usersLayoutRoute,
  path: "$id",
  component: UserRecordScreen,
  loader: ({ params }) => {
    return fetchQuery(userRecordQuery, { id: params.id }, params.orgId);
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: `${loaderData?.user.name ?? "--"} - Imoova Admin`,
      },
    ],
  }),
});

export const userDetailRoute = createRoute({
  getParentRoute: () => userRoute,
  path: "/",
  component: UserDetailsScreen,
});

export const userOrganisationsRoute = createRoute({
  getParentRoute: () => userRoute,
  path: "organisations",
  component: UserOrganisationsScreen,
});

export const userActivityRoute = createRoute({
  getParentRoute: () => userRoute,
  path: "activity",
  component: UserActivityScreen,
});
